// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginAddNewServerStep__content-aff398 {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.LoginAddNewServerStep__form-d7925a {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: start;
}

.LoginAddNewServerStep__form-control-aabb7b {
  width: 100%;
  padding-bottom: 4px;
}

.LoginAddNewServerStep__submit-d3a455 {
  margin-top: 16px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/authorization/Login/LoginViews/LoginAddNewServerStep/LoginAddNewServerStep.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF","sourcesContent":[".content {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n\n.form {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: start;\n}\n\n.form-control {\n  width: 100%;\n  padding-bottom: 4px;\n}\n\n.submit {\n  margin-top: 16px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `LoginAddNewServerStep__content-aff398`,
	"form": `LoginAddNewServerStep__form-d7925a`,
	"form-control": `LoginAddNewServerStep__form-control-aabb7b`,
	"formControl": `LoginAddNewServerStep__form-control-aabb7b`,
	"submit": `LoginAddNewServerStep__submit-d3a455`
};
module.exports = ___CSS_LOADER_EXPORT___;
